import { SxProps, Theme } from '@mui/material/styles';
import { LabeledValueBadge } from './LabeledValueBadge';
import { useLastInventorySyncDate } from './useLastInventorySyncDate';

export interface LastInventorySyncDateBadgeProps {
  dealerId: string | undefined;
  /** Optional style overrides for the outer Paper. */
  sx?: SxProps<Theme>;
}

/**
 * Displays "Last Inventory Sync Date" with loading / error / formatted value.
 * Shared by Emails grid and Inventory Feed Settings.
 */
export function LastInventorySyncDateBadge({
  dealerId,
  sx,
}: LastInventorySyncDateBadgeProps) {
  const status = useLastInventorySyncDate(dealerId);

  return (
    <LabeledValueBadge
      label="Last Inventory Sync Date"
      value={status.displayText}
      loading={status.isLoading}
      isError={status.isError}
      sx={sx}
    />
  );
}

export { useLastInventorySyncDate } from './useLastInventorySyncDate';
export { LabeledValueBadge } from './LabeledValueBadge';
